export default [
  {
    id: 1,
    titles: ['30年的精彩', '成就一位執杯大師'],
    name: '威士忌專家 林一峰',
    intro: '<p>英國劇作家莎士比亞曾說「人生苦短，若虛度年華，那短暫的人生就太長了」，林一峰老師正是莎翁口中那種不會虛度年華的人，也用一輩子的精采來驗證「喜歡的事、簡單的事情重複做，就會產生力量」的人生至理。</p><p>威士忌大師的養成，絕非一朝一夕。自從30年前威士忌打開了生命中的某扇窗後，他每每和杯中物交流的熱情，總是依舊毫無保留的濃烈並全心全意。在無所求的熱忱下，成為台灣少數得到蘇格蘭雙耳酒杯協會執杯大師榮銜的威士忌專家。</p>',
    link: 'https://www.mirrormedia.mg/story/20200322mkt002/'
  },
  {
    id: 2,
    titles: ['精彩時刻翻轉未來', '信念成就十年環保路'],
    name: '國際環保顧問 張良伊',
    intro: '<p>國際環保顧問張良伊年僅32歲，卻已創造許多不凡，大學時期以學生代表團身分，赴哥本哈根參加聯合國氣候變遷會議COP15，就此與環保運動結下不解之緣，即便曾因挫折躊躇，在理念的驅使下，至今仍為了改變環境持續奮鬥。</p><p>投身環境保護運動已有十年之久，張良伊過去曾被媒體高高舉起，卻又被重重摔下，年輕有為的「環保金童」一夕之間蒙上陰影，捲入社會輿論，不過，正因為這般歷練，才讓他更加確立了心中的那股使命召喚，締造出屬於他的精彩時刻。</p>',
    link: 'https://www.mirrormedia.mg/story/20200323mkt002/'
  },
  {
    id: 3,
    titles: ['不逞強不示弱', '成就自我精彩時刻'],
    name: '最殺女車手 沈慧蘭',
    intro: '<p>曾為國小老師的沈慧蘭，原本開車只為通勤，在一次的改裝車試駕初體驗，讓她真正體驗到人與車子間的互動，還有引擎傳遞而來的澎湃生命力，自此開啟她之後成為賽車手的這扇門。</p><p>沈慧蘭分享，在賽車場上女性的先天條件確實不如男性，認清這一點，更能清楚知道自己該如何去努力，既然確定了自己要走的路，就不要輕言放棄。多年來，她在台灣的各個房車賽及拉力賽事中獲獎無數，並曾遠赴保加利亞、羅馬尼亞、捷克等歐洲地區參加國際級拉力賽事，在人生的里程碑上，為自己拚出一場又一場的精彩時刻。</p>',
    link: 'https://www.mirrormedia.mg/story/20200324mkt001/'
  }
]
